import { Button, Form, Select, Typography } from 'antd'

import { InfoCircleOutlined as InfoIcon } from '@ant-design/icons'

const { Text } = Typography

const required = [{ whitespace: true, required: true, message: '' }]

const DateSelectInput = ({ label = 'Date', name = 'date', dates, ...props }) => {
  return (
    <Form.Item label={label} name={name} rules={required}>
      <Select dropdownMatchSelectWidth={false} {...props}>
        {dates?.map(({ key, value, disabled, note }) => (
          <Select.Option key={key} disabled={disabled}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <span>{value}</span>
              <Text italic type="secondary" style={{ fontSize: '13px', marginLeft: '16px' }}>
                {note}
              </Text>
            </div>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default DateSelectInput
